module.exports = __webpack_public_path__ + "img/1 (139).7fe1b754.png";